var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3109 3.71268L6.52484 1.14275C6.02906 0.924785 5.47984 0.956426 5.00781 1.23768L3.64516 2.04275C3.31562 2.23963 3.29187 2.78455 3.60062 3.0201L7.96172 6.34236L5.0375 8.11072L3.30969 7.20018C3.05141 7.06307 2.75156 7.0701 2.49922 7.22127L1.54328 7.78729C1.26719 7.95252 1.19297 8.37791 1.39484 8.65564L3.565 11.6545C3.74609 11.9041 4.01031 12.0482 4.28641 12.0482H8.37437C8.52281 12.0482 8.66828 12.006 8.79891 11.9287L16.9006 7.13338C18.2811 6.31424 19.3498 4.90799 19.8931 3.19588C20.1752 2.30994 19.62 1.36072 18.8184 1.36072H17.1144C16.5147 1.36072 15.9209 1.52947 15.3866 1.85291L12.3109 3.71268ZM1 16.5482C1 17.1705 1.42453 17.6732 1.95 17.6732H19.05C19.5755 17.6732 20 17.1705 20 16.5482C20 15.926 19.5755 15.4232 19.05 15.4232H1.95C1.42453 15.4232 1 15.926 1 16.5482Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeave);
export default __webpack_public_path__ + "static/media/leave.3b1ab18ec8ea2df1613a9946863e9a03.svg";
export { ForwardRef as ReactComponent };